export default __webpack_public_path__ + "static/history2-4b02f53ed083fcc99d54cffca15cc8e6.jpg";